/**
 * Copy för händelsepresentationen.
 *
 * Beskriver flödet så som det är tänkt att fungera. Scener vars funktion ligger senare i
 * ordningen bär en diskret `vision`-markering i vyn — inte en brasklapp i brödtexten.
 */

export const INKOMMANDE = [
    { id: 'd1', etikett: 'Leverantörsfaktura', bana: 'faktura' },
    { id: 'd2', etikett: 'Andrahandsansökan', bana: 'ansokan' },
    { id: 'd3', etikett: 'Felanmälan tvättstuga', bana: 'felanmalan' },
    { id: 'd4', etikett: 'Uppsägning lokal', bana: 'uppsagning' },
    { id: 'd5', etikett: 'Elräkning', bana: 'faktura' },
    { id: 'd6', etikett: 'Överlåtelseavtal', bana: 'avtal' },
    { id: 'd7', etikett: 'Mäklarbild', bana: 'avtal' },
    { id: 'd8', etikett: 'Vattenskada plan 3', bana: 'felanmalan' }
];

export const BANOR = [
    { id: 'faktura', etikett: 'Faktura' },
    { id: 'avtal', etikett: 'Avtal' },
    { id: 'ansokan', etikett: 'Ansökan' },
    { id: 'felanmalan', etikett: 'Felanmälan' },
    { id: 'uppsagning', etikett: 'Uppsägning' }
];

export const LEGITIMERING = [
    { id: 'aktor', etikett: 'Aktör', under: 'Boende · mäklare' },
    { id: 'bankid', etikett: 'BankID', under: 'Legitimering' },
    { id: 'identitet', etikett: 'Verifierad', under: 'Personnummer' },
    { id: 'behorighet', etikett: 'Behörighet', under: 'Roll i föreningen' }
];

export const AVIPOSTER = [
    { id: 'avgift', etikett: 'Månadsavgift', belopp: 4850 },
    { id: 'el', etikett: 'El', belopp: 612 },
    { id: 'garage', etikett: 'Garageplats', belopp: 950 },
    { id: 'lokal', etikett: 'Förrådslokal', belopp: 340 },
    { id: 'bokning', etikett: 'Bokningsavgift bastu', belopp: 120 }
];

export const HYRESSPÅR = [
    {
        nyckel: 'ordinarie',
        etikett: 'Hyresgäst',
        rubrik: 'Ordinarie hyresgäst',
        rader: [
            ['Objekt', 'Hyresrätt · lokal'],
            ['Kontraktstid', 'Tills vidare'],
            ['Uppsägningstid', '9 månader'],
            ['Indexuppräkning', 'KPI oktober']
        ]
    },
    {
        nyckel: 'andrahand',
        etikett: 'Andrahand',
        rubrik: 'Andrahandsupplåtelse',
        rader: [
            ['Objekt', 'Bostadsrätt · lgh 1102'],
            ['Kontraktstid', '1 år, till 2027-08-31'],
            ['Uppsägningstid', '3 månader'],
            ['Styrelsens beslut', 'Godkänd 12 maj']
        ]
    }
];

export const SPRÅKVARIANTER = [
    { nyckel: 'sv', etikett: 'Svenska', text: 'Vattnet stängs av på tisdag mellan 08 och 14.' },
    { nyckel: 'en', etikett: 'English', text: 'The water will be shut off on Tuesday between 08:00 and 14:00.' },
    { nyckel: 'pl', etikett: 'Polski', text: 'We wtorek woda będzie wyłączona w godzinach 08–14.' },
    { nyckel: 'ar', etikett: 'العربية', text: 'سيتم قطع المياه يوم الثلاثاء بين الساعة 08 و 14.' }
];
